import React, { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';
import { fetchMenuItemsTree } from 'api';
import { colors } from 'styles/colors';

const InstructionNavigation = () => {
   const [items, setItems] = useState([]);

   useEffect(() => {
      if (items.length) return;

      fetchMenuItemsTree(97).then(({ data }) => {
         const itemsPrepared = data?.items?.map((item) => ({
            id: item?.object_id,
            link: `/instrukcje/${item?.object_id}`,
            children:
               item?.children?.map((child) => ({
                  id: child?.object_id,
                  link: `/instrukcje/${child?.object_id}`,
                  label: child?.title
               })) || [],
            label: item?.title
         }));

         setItems(itemsPrepared);
      });
   }, [items.length]);

   return (
      <Nav>
         <NavListLevel1>
            {items.map((item) => (
               <NavItem key={item.id}>
                  <StyledNavLink to={item.link}>
                     <NavLabel>{item.label}</NavLabel>
                  </StyledNavLink>
                  {!!item.children.length && (
                     <NavListLevel2>
                        {item.children.map((child) => (
                           <StyledNavItem key={child.id}>
                              <StyledNavLink to={child.link}>
                                 <NavLabel>{child.label}</NavLabel>
                              </StyledNavLink>
                           </StyledNavItem>
                        ))}
                     </NavListLevel2>
                  )}
               </NavItem>
            ))}
         </NavListLevel1>
      </Nav>
   );
};

const Nav = styled.nav``;

const List = styled.ul`
   display: block;
   list-style-type: none;
   padding: 0;
   margin: 0 20px 0 0;
   width: 100%;
`;

const NavListLevel1 = styled(List)``;

const NavListLevel2 = styled(List)`
   background: #3a3f40;
   border-radius: 20px;
   padding: 10px 20px;
   margin-top: 10px;
   margin-bottom: 20px;

   button {
      margin-top: 10px;
   }
`;

const NavItem = styled.li`
   display: block;
   padding: 0;
   margin: 0;

   &:not(:last-of-type) {
      border-bottom: 1px solid ${colors.neutral30};
   }
`;

const StyledNavItem = styled(NavItem)`
   &:not(:last-of-type) {
      border-bottom: 1px solid ${colors.neutral10};
   }
`;

const StyledNavLink = styled(NavLink)`
   display: block;
   cursor: pointer;
   color: ${colors.neutral10};
   background: none;
   width: 100%;
   text-align: left;
   border: none;
   padding: 0;
   font-size: 14px;
   padding: 10px 0;
   text-decoration: none;

   &:hover {
      text-decoration: underline;
      color: ${colors.neutral50};
   }

   &.active {
      color: ${colors.primary};
   }
`;

const NavLabel = styled.span`
   display: block;
`;

export default InstructionNavigation;
